import api from './api';

export interface AppNotification {
  id: number;
  user_id?: string;
  type: string;
  title: string;
  message?: string;
  is_read: boolean;
  created_at: string;
}

export async function fetchUnreadCount() {
  const res = await api.get('/notifications/unread-count');
  return res.data?.data as number;
}

export async function fetchNotifications(opts?: { offset?: number; limit?: number }) {
  const params: any = {};
  if (typeof opts?.offset === 'number') params.offset = Math.max(0, Math.floor(opts.offset));
  if (typeof opts?.limit === 'number') params.limit = Math.max(1, Math.floor(opts.limit));
  const res = await api.get('/notifications', { params });
  return res.data?.data as AppNotification[];
}

export async function markNotificationRead(id: number) {
  await api.post(`/notifications/${id}/read`);
}

export async function deleteNotification(id: number) {
  await api.delete(`/notifications/${id}`);
}

export async function markAllNotificationsRead() {
  await api.post('/notifications/read-all');
}


